import { DialogSize } from '../../../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { useMultiForm } from '../../../../../../../react-commons/hooks/useMultiForm';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultVideoAttachmentContentResource,
    useVideoAttachmentContentActions,
    VideoAttachmentContentMutationResourceSchema,
} from '../../../../../resource/resources/artifacts/attachment/videoAttachmentContentResource';
import {
    defaultVideoAttachmentResource,
    useVideoAttachmentActions,
    VideoAttachmentMutationResourceSchema,
    type VideoAttachmentResource,
} from '../../../../../resource/resources/artifacts/attachment/videoAttachmentResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { handleMutationResult } from '../../../../util/utilFunctions';
import { VideoAttachmentContent } from './VideoAttachmentContent';

export const VideoAttachmentCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: VideoAttachmentResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const videoAttachmentActions = useVideoAttachmentActions();
    const videoAttachmentContentActions = useVideoAttachmentContentActions();
    const addVideoAttachment = videoAttachmentActions.useAddResource();
    const addVideoAttachmentContent = videoAttachmentContentActions.useSetResource();

    const { form: videoForm, formNames: videoFormNames } = useMyForm({
        schema: VideoAttachmentMutationResourceSchema,
        defaultValues: {
            ...defaultVideoAttachmentResource,
            ...autoGeneratedProps,
        },
    });
    const { form: videoContentForm, formNames: videoContentFormNames } = useMyForm({
        schema: VideoAttachmentContentMutationResourceSchema,
        defaultValues: defaultVideoAttachmentContentResource,
    });
    const { onSubmit, form } = useMultiForm(
        {
            primary: videoForm,
            secondary: videoContentForm,
        },
        async (data) => {
            await addVideoAttachment.mutateAsync(
                {
                    resource: data.primary,
                    parentId,
                },
                {
                    onSuccess: handleMutationResult((value) => {
                        console.log(value.content);
                        console.log(data.secondary);
                        addVideoAttachmentContent.mutate(
                            {
                                resource: data.secondary,
                                parentId: value.content?.id,
                                withoutGrowl: true,
                            },
                            {
                                onSuccess: handleMutationResult((_) => {
                                    if (onCreated && value.content?.objectId) {
                                        onCreated(value.content.id, value.content.objectId);
                                    }
                                    onClose();
                                }),
                            }
                        );
                    }),
                }
            );
        }
    );

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Video Attachment'}
            resourceType={[ResourceType.VIDEO_ATTACHMENT, ResourceType.VIDEO_ATTACHMENT_CONTENT]}
            dialogSize={DialogSize.MEDIUM_LARGE}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <VideoAttachmentContent
                    form={videoForm}
                    formNames={videoFormNames}
                    contentForm={videoContentForm}
                    contentFormNames={videoContentFormNames}
                    readOnly={false}
                />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
